<template>
  <div class="flex flex-col items-center mb-4">
      <img src="../assets/img/sip.svg" class="h-32 w-32">
      <p class="text-blue-800 lg:px-40 text-center">देश विदेशमा लकडाउनको कारणले रोजगारी क्षेत्रमा पर्न गएको असरलाई ध्यानमा राखी नेपालीहरुलाई अब देशमै रोजगारी, तालिम वा स्व-रोजगारीको अवसर प्रदान गर्ने प्रयास गरिदैछ।
आजै आफ्नो विवरण भरी दर्ता गर्नुहोस्।</p>
      <button class="bg-yellow-600 px-4 py-2 mt-4 rounded-md text-white hover:bg-yellow-500 hover:text-white transition ease-out duration-500">विवरण दर्ता गर्नुहोस्</button>
  </div>
</template>

<script>
export default {

}
</script>

<style>

</style>